import * as React from "react";
import { Locale } from "@linkfluence/models/locale";
import WorkspaceSearchList from "@radarly/components/navigation/switcher/search/workspaces";
import { useSearchWorkspaces } from "@radarly/core/workspace/use-cases";
import { IRouterService } from "@radarly/shared/router";

interface IProps {
  search: string;
  locale: Locale;
  onClickWorkspace: () => void;
  router: IRouterService;
}

const RadarlySharedNavigationSwitcherSearchWorkspaces = ({
  search,
  locale,
  onClickWorkspace,
  router,
}: IProps) => {
  const { workspaces, loading, fetchMore, canFetchMore } =
    useSearchWorkspaces(search);
  return (
    <WorkspaceSearchList
      workspaces={workspaces}
      locale={locale}
      loading={loading}
      fetchMore={fetchMore}
      canFetchMore={canFetchMore}
      onClickWorkspace={onClickWorkspace}
      router={router}
    />
  );
};

export default RadarlySharedNavigationSwitcherSearchWorkspaces;
